import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { RootService } from 'src/app/services/root/root.service';
import { Balance } from './models/balance/balance.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {
  balance: any;
  clients: any;
  options: any;
  filtered: any;
  balanceForm: FormGroup;
  dataSource = new MatTableDataSource<Balance[]>();
  displayedColumns: string[] = ['empresa', 'comprobante', 'fecha', 'debe', 'saldoComprobante', 'vencimiento', 'pdf'];
  endpoint = 'http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/ctasaldos.r';
  saldo_total: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private spinner: NgxSpinnerService, private _rootService: RootService,
    private formBuilder: FormBuilder, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.spinner.show();
    this.clients = JSON.parse(sessionStorage.getItem("session"));

    if (this.clients.dsSesion.ttsesion[0].tipo.toLowerCase() == 'cliente') {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      /** form initiated */
      this.balanceForm = this.formBuilder.group({
        code: [this.clients.dsSesion.ttcliente[0].codigo, Validators.required]
      });

      this.onSubmit(this.balanceForm);
      this.spinner.hide();

    }

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    /** form initiated */
    this.balanceForm = this.formBuilder.group({
      code: ['', Validators.required]
    });

    this.options = this.clients["dsSesion"]["ttcliente"];

    this.spinner.hide();

  }

  onSubmit(obj: FormGroup) {
    this.spinner.show();
    /** check if form is invalid */
    if (obj.status === "INVALID") {
      this.spinner.hide()
      return this.showAlert("Campos requeridos*", "Cerrar");
    }

    /** callback to endpoint */
    return this._rootService.balance(obj.value.code["codigo"]).subscribe(

      response => {
        if (_.get(response['dssaldos'], 'movi') != undefined) {
          this.dataSource.data = _.get(response['dssaldos'], 'movi');
          this.saldo_total = response['dssaldos']['ttsaldo']
          this.lastItem();
          this.spinner.hide();
        } else {
          this.dataSource.data = response['dssaldos']['movi'];
          this.showAlert("No se encontraron datos", "Cerrar");
          this.spinner.hide();
        }
        this.spinner.hide();
      },

      error => {
        this.showAlert("Error, vuelva a intentar", "Cerrar");
        this.spinner.hide();
      }
    );
  }

  /** filter clients by name and code */
  filterClients(value: any) {
    let filterValue = value.toString().toUpperCase();
    this.filtered = this.options.filter(client => client.nombre.toUpperCase().indexOf(filterValue) === 0 || client.codigo.toString().includes(filterValue));
  }

  displayNm(client) {
    return client ? client["nombre"] : undefined;
  }

  /** Alert method */
  showAlert(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  lastItem(): void {
    this.balance = this.dataSource.data[this.dataSource.data.length - 1]["saldo"];
  }

  /** Filter */
  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
